import Vuex from 'vuex';
import { Report } from '@/models/Report';
import { Vue } from 'vue-property-decorator';
import { Form, FormElement, FormElementTag } from '../models/Form';

import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';

Vue.use(Vuex);
export interface IVuexStore {
    loading: boolean;
    form: Form | null;
    report: Report | null;
    accessCode: string;
    errors: string[];
    elements: FormElement[];
    answers: { [elementId: number]: any };
    points: any;
    tags: { [tagId: number]: FormElementTag };
    updated: number;
}

const vuexStore = new Vuex.Store({
    state: {
        loading: true,
        form: null,
        report: null,
        accessCode: '',
        errors: [],
        elements: [],
        answers: {},
        points: null,
        tags: {},
        updated: 0,
    },
    getters,
    mutations,
    actions,
    modules: {},
});

vuexStore.subscribe((mutation: any, state: any) => {
    const storageEvents = ['addAnswer', 'prev'];

    if (storageEvents.indexOf(mutation.type) > -1) {
        const storageKey = `rbb:client:${state.form.id}:${state.accessCode}`;
        const storageString = JSON.stringify({
            answers: state.answers,
            elements: state.elements,
            tags: state.tags,
            updated: state.updated,
        });

        localStorage[storageKey] = storageString;
    }
});

export default vuexStore;
